import { ChannelNameTokens, Rental } from '@tokeet-frontend/tv3-platform'

export const rateMappingDisabledChannels = [
  ChannelNameTokens.Holidu,
  ChannelNameTokens.RentalsUnited,
  ChannelNameTokens.GoogleVacationRentals,
  ChannelNameTokens.Hvmi,
  ChannelNameTokens.Homeaway,
  ChannelNameTokens.Hopper,
]

export type FeedChannelStatus = 'applied' | 'not-applied'

export interface FeedTax {
  name: string
  type: 'flat' | 'pct'
  modality:
    | 'per_person_stay'
    | 'per_person_night'
    | 'per_stay'
    | 'per_night'
    | 'per_hour'
    | 'per_minute'
    | 'per_week'
    | 'per_unit'
    | 'per_child'
  value: number
  included: string | number
  code: string
  decimals: number
  attributes?: any
}

export interface FeedFee {
  name: string
  type: 'flat' | 'pct'
  modality:
    | 'per_person_stay'
    | 'per_person_night'
    | 'per_stay'
    | 'per_night'
    | 'per_hour'
    | 'per_minute'
    | 'per_week'
    | 'per_unit'
    | 'per_child'
  value: number
  included: string | number
  code: string
  attributes?: any
}

export interface UpdateFeedConfig {
  pkey: string
  status: number
  payment_terms: string
  payment_conditions: string
  cancellation_policy: string
  taxes: FeedTax[]
  fees: FeedFee[]
}

export interface HomeAwayConfigForm {
  cancellation_policy: string
  booking_policy: string
  guest_minimum_age: number
  payment_terms: { [key: string]: { days?: number; percent: number } }
  tc_accepted: number
}

export interface UpdateHomeAwayConfig {
  cancellation_policy: string
  booking_policy: string
  guest_minimum_age: number
  payment_terms: { [key: string]: { days?: number; percent: number } }
  tc_accepted: number
}

export interface FeedConfig {
  status: number
  payment_terms: any
  payment_conditions: string
  cancellation_policy: string
  taxes: FeedTax[]
  fees: FeedFee[]
}

export interface HomeAwayRentalConfig {
  attributes?: {
    availabilitypull?: number
    ratepull?: number
  }
  archived: number
  account: number
  status: number
  date_enabled: number
  created: number
  channel_id: string
  pkey: string
  last_sync: number
  rental_id: string
  channel_url: string
  channel_live: number
}

export interface HomeAwayChannelConfig extends FeedConfig {
  pkey: string
  created: number
  archived: number
  deleted: number
  account: number
  last_sync: number
  date_enabled: number
  tc_accepted: number
  guest_minimum_age: number
  payment_terms: { [type: string]: { percent: number; days?: number } }
}

export interface HomeAwayRentalConfigView extends HomeAwayRentalConfig {
  rental: Rental
  rental_name: string
}

export interface AirbnbSyncSettings {
  booking_settings: boolean
  pricing_settings: boolean
  availability_rules: boolean
}

export interface AirbnbChannelConfig {
  ignoreHoldEvents?: boolean
  syncSettings?: AirbnbSyncSettings
}
